var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"about-footer-menu"},[_c('a',{staticClass:"footer-link",attrs:{"href":"https://frisky.fm/about/privacy-policy","target":"_blank"}},[_vm._v(" Privacy Policy ")]),_c('a',{staticClass:"footer-link",attrs:{"href":"https://frisky.fm/about/terms","target":"_blank"}},[_vm._v(" Terms of Use ")])])
}]

export { render, staticRenderFns }